module.exports = __webpack_public_path__ + "img/psd.cd45dcc0.svg";